import '@web/shared-digital-library/icons/svg-originals/chevron-top-slim.svg';
import throttle from 'lodash/throttle';
var SCROLL_THRESHOLD = 230;
export default {
  name: 'MdmBackToTop',
  data: function data() {
    return {
      show: false
    };
  },
  mounted: function mounted() {
    this.show = window.scrollY > SCROLL_THRESHOLD;
    this.bindScrollTop();
  },
  destroyed: function destroyed() {
    this.unbindScrollTop();
  },
  methods: {
    scrollTop: function scrollTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    bindScrollTop: function bindScrollTop() {
      window.addEventListener('scroll', this.handleScroll, {
        passive: true
      });
    },
    unbindScrollTop: function unbindScrollTop() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    handleScroll: throttle(function handleScroll() {
      this.show = window.scrollY > SCROLL_THRESHOLD;
    }, 200)
  }
};